import { render, staticRenderFns } from "./VersionEndCardSettings.vue?vue&type=template&id=d008a49c&lang=pug&"
import script from "./VersionEndCardSettings.vue?vue&type=script&lang=js&"
export * from "./VersionEndCardSettings.vue?vue&type=script&lang=js&"
import style0 from "./VersionEndCardSettings.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports